/**
 * Usage example
 *
 * This will give you delta of axises
 *
 * const { dx, dy } = delta({
 *  x0: 0,
 *  y0: 0,
 *  x1: 100,
 *  y1: 100,
 * })
 */

type Payload = {
  x0: number
  y0: number
  x1: number
  y1: number
}

type Delta = {
  dx: number
  dy: number
}

const delta = (payload: Payload): Delta => {
  const { x0, y0, x1, y1 } = payload as Payload

  return {
    dx: x1 - x0,
    dy: y1 - y0,
  }
}

export default delta
